import { fileClient } from './api-grpc';
import { type File as InstallationFile } from '../gen/proto/api/gateway/v1/file_pb';

export const filesApi = {
  async createUploadUrl(installationUuid: string, fileName: string, contentType: string): Promise<string> {
    const response = await fileClient.createUploadUrl({
      installationUuid,
      fileName,
      contentType,
    });
    if (!response.url) {
      throw new Error('Error creating upload url');
    }
    return response.url;
  },

  async completeUploadRequest(
    objectKey: string,
    sizeBytes: bigint,
    checksum: string,
    fileName: string,
    installationUuid: string,
  ): Promise<InstallationFile> {
    const response = await fileClient.completeUpload({
      objectKey,
      sizeBytes,
      checksum,
      fileName,
      installationUuid,
    });
    if (!response.file) {
      throw new Error('Error completing upload');
    }
    return response.file;
  },
  async createDownloadUrl(fileUuid: string): Promise<string> {
    const response = await fileClient.createDownloadUrl({
      fileUuid,
    });
    if (!response.url) {
      throw new Error('Error creating download');
    }
    return response.url;
  },

  async getFilesByUuidInstallation(uuid: string): Promise<InstallationFile[]> {
    const response = await fileClient.getFilesByInstallationUuid({
      installationUuid: uuid,
    });
    if (!response.files) {
      throw new Error('Could not get files from installation state');
    }
    return response.files;
  },

  async uploadFile(presignedUrl: string, selectedFile: File): Promise<void> {
    const uploadResponse = await fetch(presignedUrl, {
      method: 'PUT',
      body: selectedFile,
    });
    if (!uploadResponse.ok) {
      throw new Error('Upload failed');
    }
  },

  async deleteFile(fileUuid: string): Promise<void> {
    await fileClient.deleteFile({ fileUuid });
  },
};
